"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let focusStack = [];
function saveFocus(element) {
    if (element && document.contains(element)) {
        focusStack.push(element);
    }
}
function restoreFocus() {
    while (focusStack.length) {
        const previous = focusStack.pop();
        if (previous && document.contains(previous)) {
            previous.focus({ preventScroll: true });
            return;
        }
    }
    document.body.focus({ preventScroll: true });
}
function patchKlaviyoDialog(dialog) {
    saveFocus(document.activeElement);
    const titleSpan = dialog.querySelector('p > span');
    if (titleSpan) {
        titleSpan.id = 'klaviyo-popup-title';
        dialog.setAttribute('aria-labelledby', 'klaviyo-popup-title');
        dialog.removeAttribute('aria-label');
        dialog.setAttribute('aria-live', 'assertive');
    }
    dialog.setAttribute('tabindex', '-1');
    setTimeout(() => dialog.focus(), 50);
    const closeBtn = dialog.querySelector('button[aria-label="Close dialog"]');
    closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener('click', () => {
        restoreFocus();
    });
}
const observer = new MutationObserver(mutations => {
    var _a;
    for (const mutation of mutations) {
        for (const node of Array.from(mutation.addedNodes)) {
            if (!(node instanceof HTMLElement))
                continue;
            const klaviyoDialog = node.matches('[role="dialog"]') && node.querySelector('form.klaviyo-form')
                ? node
                : (_a = node.querySelector('[role="dialog"] form.klaviyo-form')) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (klaviyoDialog)
                patchKlaviyoDialog(klaviyoDialog);
            const attentiveIframe = node.querySelector('iframe#attentive_creative');
            if (attentiveIframe)
                patchAttentiveIframe(attentiveIframe);
            const cookieBanner = node.matches('#CybotCookiebotDialog')
                ? node
                : node.querySelector('#CybotCookiebotDialog');
            if (cookieBanner)
                patchCookieBanner(cookieBanner);
        }
    }
});
function patchAttentiveIframe(iframe) {
    saveFocus(document.activeElement);
    const observer = new MutationObserver(() => {
        if (!document.body.contains(iframe)) {
            observer.disconnect();
            restoreFocus();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}
function patchCookieBanner(banner) {
    saveFocus(document.activeElement);
    banner.setAttribute('tabindex', '-1');
    const heading = banner.querySelector('.CybotCookiebotDialogBodyContentHeading');
    if (heading)
        banner.setAttribute('aria-labelledby', heading.id);
    setTimeout(() => banner.focus({ preventScroll: true }), 50);
    const closeButtons = banner.querySelectorAll('button, input[type="button"], input[type="submit"]');
    closeButtons.forEach(btn => btn.addEventListener('click', () => {
        restoreFocus();
    }));
}
observer.observe(document.body, { childList: true, subtree: true });
Array.from(document.querySelectorAll('[role="dialog"]'))
    .filter(dialog => dialog.querySelector('form.klaviyo-form'))
    .forEach(dialog => patchKlaviyoDialog(dialog));
